/* eslint-disable */

export function addStat (productId, configCode, region) {
  productId = parseInt(productId)

  if (typeof configCode === 'undefined') {
    configCode = ''
  }

  // Google Tag Manager
  if (productId !== 15376 && region !== 'ru') {
    if (this.$gtm) {
      this.$gtm.enable(true)
    }
  }

  (function () {
    const script = document.createElement('script')
    script.innerHTML = '(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};' +
    'm[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})' +
    '(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");'
    document.getElementsByTagName('head')[0].prepend(script)
  })()

  ym(4303060, "init", {
    clickmap:true,
    trackLinks:true,
    accurateTrackBounce:true,
    webvisor:true,
    trackHash:true,
    params: {
      productId: productId
    }
  });

  if (configCode === 'demo') {
    ym(4303060,'reachGoal','b2p_show_widget_demo')
  }

  window.yaParams = { "productId": productId };
  ym(12446476, 'params', window.yaParams || {});

  if (configCode === 'litres') {
    ym(2199583, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true,
      trackHash:true,
      ecommerce:"dataLayer"
    });

    try {
      if (typeof window.gtag !== 'undefined') {
        window.gtag('config', 'UA-15543008-1')
      }
    } catch (e) {
      console.log(e)
    }
  }


  if (configCode === 'scrpro') {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/105450541"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(105450541, 'init', {
      webvisor: true,
      clickmap: true,
      ecommerce: "dataLayer",
      accurateTrackBounce: true,
      trackLinks: true
    });
  }

  if (productId == 26578) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/95625322"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(95625322, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true
    });

    ym(95625322, 'reachGoal', 'open_widget')
  }

  if (productId == 26285) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/106237119"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(101503990, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true
    });

    ym(101503990, 'reachGoal', 'open_widget')
  }

  if (productId == 14103) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/56585392"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(56585392, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true
    });
  }

  if (productId == 27732) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/101503990"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(106237119, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true
    });

    ym(106237119, 'reachGoal', 'open_widget')
  }

  // TODO: Youtalk:18831
  if (productId == 18831) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/49493728"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(49493728, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true
    });
  }

  // ИВ РОШЕ Казахстан
  if (productId == 16033) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/92255093"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(92255093, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true
    });
  }

  // Аскона Казахстан
  if (productId == 17100) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/92255125"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(92255125, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true
    });
  }

  // MIR VR
  if (productId == 21094) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/68358556"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(68358556, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true
    });
  }

  if (productId === 19157) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/86971016"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(86971016, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true
    });
  }

  // Askona TEST
  if (configCode == 'askona') {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/1383371"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(1383371, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true,
      trackHash:true,
      ecommerce:"dataLayer"
    });
  }

  if (productId == 25795) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/84418648"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(84418648, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor:true
    });
  }

  // Divan.ru
  if (productId === 25012) {
    const noscript = document.createElement('noscript')
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/31956481"; style="position:absolute; left:-9999px;" alt="" /></div>'
    document.body.prepend(noscript)

    ym(31956481, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      trackHash:true
    });
  }
}
